// eslint-disable-next-line func-names
(function (Drupal, $, cookies) {
  const initWarningBanner = (el) => {
    const $warningBanner = $(el);
    const $message = $warningBanner.find('.warning-banner__message');
    const $siteHeader = $('.site-header');
    const $nav = $('.site-header__body');
    const $closeButton = $('button[data-action="hide-warning"]');
    const bannerCookie = cookies.get('warning-banner');
    const $searchForm = $('.region.search');

    const siteHeaderHTML = $siteHeader.get(0);

    const setProperties = (height) => {
      if ($searchForm.length > 0) {
        const navHeight = $nav.outerHeight();
        $searchForm.css({ top: `${height - navHeight}px` });
      }
    };

    function checkForItemCookies(element, cookie) {
      if (!cookie) {
        element.removeClass('display-none');
      } else {
        element.remove();
      }
    }

    if ($warningBanner.length > 0) {
      if ($message.hasClass('not-published')) {
        cookies.remove('warning-banner');
        $warningBanner.remove();
        return;
      }

      checkForItemCookies($warningBanner, bannerCookie);

      if (typeof ResizeObserver !== 'undefined') {
        const heightObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => setProperties(entry.contentRect.height));
        });

        heightObserver.observe(siteHeaderHTML);
      } else {
        $(window).on('load resize', () => {
          const siteHeaderHeight = $siteHeader.outerHeight();
          setProperties(siteHeaderHeight);
        });
      }
    }

    $closeButton.on('click', () => {
      cookies.set('warning-banner', 'hidden', { expires: 1, path: '/' });
      $warningBanner.addClass('display-none');

      setTimeout(() => {
        $warningBanner.remove();
      }, 150);

      const siteHeaderHeight = $siteHeader.outerHeight();
      setProperties(siteHeaderHeight);
    });
  };
  Drupal.behaviors.mstWarningBanner = {
    attach(context) {
      $('.warning-banner', context).each((index, el) => initWarningBanner(el));
    },
  };
}(Drupal, jQuery, window.Cookies));
